<template>
  <wo-region>
    <wo-layout>
      <wo-title tag-name="h3" v-t="'salespointEdit.title'" />
    </wo-layout>
    <sales-point-edit :tags="tags" :value="pending" :related-company="company" @input="confirm" @cancel="cancel" />
  </wo-region>
</template>

<script>

import { mapState } from 'vuex'

import { SALES_POINT } from '@/routes/sales-point'

import { SalesPoint, SalesPointTag, SalesPointTagTypeEnum } from '@/model/sales-point'

import SalesPointEdit from '@/components/sales-point/SalesPointEdit'

export default {
  components: { SalesPointEdit },
  data () {
    return {
      pending: new SalesPoint(),
      tags: []
    }
  },
  computed: mapState({
    env: state => state.environment.current,
    company: state => state.company.company,
    currentUser: state => state.identity.currentUser
  }),
  created () {
    this.pending.brand = this.env
    this.tags.push(SalesPointTag.for(SalesPointTagTypeEnum.values.BRAND, this.env))
  },
  methods: {
    cancel () {
      this.$router.go(-1)
    },
    confirm (salesPoint) {
      this.$router.push({ name: SALES_POINT, params: { salesPointId: salesPoint.id } })
    }
  }
}
</script>
